import { Grid } from '@material-ui/core';
import { formatDateTimeReadable, Merchant, MerchantContract } from '@nemuru-eng/js-api-client';

import { TextFormField } from '@/components/shared/components/NewContextForms/TextFormField';

import { StatusTagType } from '../../../../../../../../../config/types';
import { useScreen } from '../../../../../../../../../hooks/useScreen';
import { StatusTag } from '../../../../../../../../shared/components/StatusTag/StatusTag';

interface MerchantContractStatusViewProps {
  merchantContract: MerchantContract;
  merchant: Merchant;
}

export const MerchantContractStatus = ({ merchantContract, merchant }: MerchantContractStatusViewProps) => {
  const { isMobile } = useScreen();
  return (
    <Grid container spacing={isMobile ? 0 : 4}>
      <Grid item xs={12} lg={6}>
        <TextFormField
          label={'CONTRACT_SENT_DATE'}
          value={merchantContract.sentDate ? formatDateTimeReadable(merchantContract.sentDate) : undefined}
          name={merchant.id}
        />
        <TextFormField
          label={'CONTRACT_SIGNED_DATE'}
          value={merchantContract.signedDate ? formatDateTimeReadable(merchantContract.signedDate) : undefined}
          name={merchant.id}
        />
      </Grid>
      <Grid item xs={12} lg={6}>
        <TextFormField
          underlinedOnReadOnly={true}
          label={'CONTRACT_STATUS'}
          value={
            merchantContract.isSigned ? (
              <StatusTag
                type={
                  merchantContract.isSigned
                    ? StatusTagType.SUCCESS
                    : merchantContract.isSent
                    ? StatusTagType.INFO
                    : StatusTagType.DEFAULT
                }
                labelTextId={merchantContract.isSigned ? 'SIGNED' : merchantContract.isSent ? 'SENT' : 'NOT_SENT'}
              />
            ) : (
              <></>
            )
          }
          name={merchant.id}
          boxProps={{ py: '6px' }}
        />
      </Grid>
    </Grid>
  );
};
